import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { FieldSelectMultiStore } from 'stores/local/shared/form/FieldSelectStore';
import { OptionEntity } from 'types/OptionEntity';

import s from './SummaryValue.module.scss';

export type FormatValue = (value: OptionEntity[]) => string;

type Props = {
  store: FieldSelectMultiStore;
  formatValue?: FormatValue;
};

const joinValues: FormatValue = (value) => value.map((item) => item.value).join(', ');

const SummaryValue: React.FC<Props> = ({ store, formatValue = joinValues }) => (
  <span className={s.root}>{formatValue(store.value)}</span>
);

export default observer(SummaryValue);
